import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, TextField, Autocomplete, Avatar, Typography, Button } from "@mui/material";

const API_URL = process.env.REACT_APP_API_URL;

const ExpertSearch = ({ requestId, onApprove }) => {
  const [searchText, setSearchText] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = (text) => {
    setSearchText(text);

    if (!text.trim()) {
      setOptions([]);
      return;
    }

    setLoading(true);

    axios
      .get(`${API_URL}/api/search_experts/`, {
        params: { query: text, exclude_ids: "" } // You can pass exclude IDs if needed
      })
      .then((res) => {
        setOptions(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  return (
    <Autocomplete
      freeSolo
      options={options}
      getOptionLabel={(option) => {
        const user = option.user;
        if (user) return `${user.name} ${user.surname} - ${option.expert.designation}`;
        return option.expert.designation || "Unknown";
      }}
      loading={loading}
      onInputChange={(event, value) => handleSearch(value)}
      renderOption={(props, option) => {
        const user = option.user;
        return (
          <Box {...props} display="flex" alignItems="center" gap={1}>
            <Avatar src={user?.image || ""} sx={{ width: 40, height: 40 }} />
            <Box>
              <Typography fontWeight="bold">{user?.name} {user?.surname}</Typography>
              <Typography variant="body2">{option.expert.designation}</Typography>
            </Box>
            <Button
              variant="contained"
              size="small"
              sx={{ ml: "auto" }}
              onClick={(e) => {
                e.stopPropagation();
                onApprove(option.expert.user_id);
              }}
            >
              Approve
            </Button>
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Search Experts"
          placeholder="Type name, designation, or area"
          variant="outlined"
          fullWidth
        />
      )}
    />
  );
};

export default ExpertSearch;
